import { Injectable } from '@angular/core';
import { CouchdbService } from './couchdb.service';
import { dataModel } from '../../models/data.model';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})

export class CommunicationService {
    data: dataModel;
    constructor(private databaseDocument: CouchdbService, private authService: AuthenticationService) {
        this.databaseDocument.getObservable().subscribe(data => {
            this.data = data;
        });
     }

     loadData() {
        this.databaseDocument.getObservable().subscribe(data => {
            this.data = data;
        });
     }
}
